import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import type { AltaMedica } from 'models/altaMedica_model';
import {
  createAltaMedica,
  editAltaMedica,
  infoAltaMedica,
  aceptarRechazarAltaMedica,
  deleteAltaMedica,
} from 'repositories/altaMedica_repository';

interface AltaMedicaState {
  loading: boolean;
  error: string | null;
}

const initialState: AltaMedicaState = {
  loading: false,
  error: null,
};

export const agregarAltaMedica = createAsyncThunk(
  'altaMedica/agregarAltaMedica',
  async (data: AltaMedica, { rejectWithValue }) => {
    try {
      await createAltaMedica(data);
    } catch {
      return rejectWithValue('Error al crear alta médica');
    }
  },
);

export const editarAltaMedica = createAsyncThunk(
  'altaMedica/editarAltaMedica',
  async ({ data, altaMedicaId }: { data: AltaMedica; altaMedicaId: string }, { rejectWithValue }) => {
    try {
      await editAltaMedica(data, altaMedicaId);
    } catch {
      return rejectWithValue('Error al editar alta médica');
    }
  },
);

export const masInfoAltaMedica = createAsyncThunk(
  'altaMedica/masInfoAltaMedica',
  async ({ data, altaMedicaId }: { data: AltaMedica; altaMedicaId: string }, { rejectWithValue }) => {
    try {
      await infoAltaMedica(data, altaMedicaId);
    } catch {
      return rejectWithValue('Error al actualizar información de alta médica');
    }
  },
);

export const responderAltaMedica = createAsyncThunk(
  'altaMedica/responderAltaMedica',
  async ({ data, altaMedicaId }: { data: AltaMedica; altaMedicaId: string }, { rejectWithValue }) => {
    try {
      await aceptarRechazarAltaMedica(data, altaMedicaId);
    } catch {
      return rejectWithValue('Error al responder alta médica');
    }
  },
);

export const eliminarAltaMedica = createAsyncThunk(
  'altaMedica/eliminarAltaMedica',
  async (id: string, { rejectWithValue }) => {
    try {
      await deleteAltaMedica(id);
    } catch {
      return rejectWithValue('Error al eliminar alta médica');
    }
  },
);

export const altaMedicaSlice = createSlice({
  name: 'altaMedica',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(agregarAltaMedica.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(agregarAltaMedica.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(agregarAltaMedica.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default altaMedicaSlice.reducer;
